<div
  class="data-table"
  [class.data-table--with-caption]="isCaptionVisible"
>
  <div
    *ngIf="!isSimpleTable && isToolbarTopVisible"
    class="data-table__toolbar-top"
  >
    <div class="data-table__toolbar-top__actions">
      <app-super-master-selector
        (superMasterSelectorClick)="onSuperMasterSelectorClick($event)"
        *ngIf="isSuperMasterSelectorVisible && isSuperMaster"
        class="qima-mr-xs"
      ></app-super-master-selector>
      <ng-content select=".table-toolbar-top-actions"></ng-content>
    </div>
    <div class="data-table__toolbar-top__search">
      <ng-content select=".table-toolbar-top-search"></ng-content>
    </div>
  </div>
  <div
    *ngIf="isCaptionVisible"
    class="data-table__caption"
  >
    <ng-content select=".table-caption"></ng-content>
  </div>
  <app-table
    class="data-table__inner-table"
    (dataTableIconCellClick)="onTableIconClick($event)"
    (tableCheckboxClick)="onTableCheckboxClick($event)"
    (tableDecisionApprove)="onTableDecisionApprove($event)"
    (tableDecisionReject)="onTableDecisionReject($event)"
    (tableHeadCheckboxClick)="onTableHeadCheckboxClick($event)"
    (tableRowClick)="onTableRowClick($event)"
    (tableSort)="onTableSort($event)"
    [layoutStyle]="layoutStyle"
    [tableActiveRowIndex]="activeRowIndex"
    [tableBeforeCheckboxClick]="beforeCheckboxClick"
    [tableBeforeRowClick]="beforeRowClick"
    [tableBottom]="bottom"
    [tableCanClick]="canClick"
    [tableData]="tableViewData"
    [tableEmptyMessage]="emptyMessageState"
    [tableGetRowTooltipConfig]="getRowTooltipConfig"
    [tableHasSelectedBackgroundColor]="hasSelectedBackgroundColor"
    [tableHeaders]="tableHeaders"
    [tableIsDragScrollEnabled]="isDragScrollEnabled"
    [tableIsHeadVisible]="isHeadVisible"
    [tableIsHeaderFix]="isHeaderFix"
    [tableIsHover]="isHover"
    [tableIsSelectRowOnRowClick]="isSelectRowOnRowClick"
    [tableIsStriped]="isStriped"
    [tableTop]="top"
  ></app-table>
  <div
    *ngIf="!isSimpleTable && isToolbarBottomVisible"
    [ngClass]="{ 'data-table__toolbar-bottom--is-absolute': isBottomAbsolute }"
    class="data-table__toolbar-bottom"
  >
    <ng-content select=".table-toolbar-bottom-content"></ng-content>
    <qima-pagination
      (qimaPaginationActivePageChange)="tablePaginationActivePageChange($event)"
      (qimaPaginationEntriesPerPageChange)="tablePaginationPageSizeChange($event)"
      *ngIf="isPaginationVisible"
      [qimaPaginationActivePage]="activePage"
      [qimaPaginationEntriesAmount]="tableTotalSize"
      [qimaPaginationEntriesPerPageList]="pageSizes"
      [qimaPaginationEntriesPerPage]="entriesPerPage"
      [qimaPaginationHasEntriesPerPageSelect]="true"
    ></qima-pagination>
  </div>
</div>
